import React from 'react';
import Page from '../../containers/page';
import FormBuilder from '../../form-builder';
import RouteComponent from '../../helpers/route';

import logo from '../../assets/logo.png';
import { API_ENDPOINT } from '../../constants';

class LoginPage extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {
            total: 20,
            items: [{
                name: 'Test'
            }]
        }
    }

    componentDidMount() {
        this._onLoad();
    }

    componentDidUpdate(prevProps, prevState) {

    }
    login = (data) => {
        // /users/login
        console.log(data)

        fetch(API_ENDPOINT + "/users/login", {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error
                    })
                } else {

                    localStorage.setItem("authToken", result.token);
                    this.props.verifyUser(() => this.props[0].history.push('/users'));



                }
            });
    }

    render() {
        let params = this._getParams();


        return (
            <div>

                <section className="login-page">
                    <div className="login-page-box-container">
                        <div className="login-page-box">
                            <img src={logo} className="logo" />
                            <FormBuilder
                                addButtonText={'Dodaj'.translate(this.props.lang)}
                                onSubmit={(data) => {
                                    this.login(data)
                                }}
                                initialValues={{

                                }}
                                fields={[
                                    {
                                        type: 'row',
                                        children: [
                                            {
                                                type: 'col',
                                                width: { lg: 8 },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'username',
                                                        next: 'password',
                                                        placeholder: 'Username',
                                                        asyncValidation: true,
                                                        validate: [
                                                            (value, values) => { if (!value || value == '') return "Wrong username!" }
                                                        ]
                                                    },
                                                    {
                                                        type: 'text',
                                                        textType: 'password',
                                                        name: 'password',
                                                        placeholder: 'Password',
                                                        next: 'submit',
                                                        asyncValidation: true,
                                                        validate: [
                                                            (value, values) => { if (!value || value == '') return "Wrong password!" }
                                                        ]
                                                    },

                                                ]
                                            },
                                            {
                                                type: 'col',
                                                width: { lg: 12 },
                                                children: [
                                                    {
                                                        name: 'submit',
                                                        type: 'button',
                                                        action: 'submit',
                                                        children: 'LOG IN',
                                                        className: ''
                                                    },
                                                ]
                                            }
                                        ]
                                    }
                                ]}
                            ></FormBuilder>
                        </div>
                        {/* <div className="certificat">
                            <Isvg src={certificat} />
                            <div className="certificat-content">
                                <h6>SSL sertifikat: ICM</h6>
                                <p>Važi do: 06.02.2031.</p>
                            </div>
                        </div> */}
                    </div>
                </section>

            </div>
        )
    }
}

export default Page(LoginPage);
